<template>
    <div></div>
</template>
<script>
    export default {
        methods: {
            donutSegment(start, end, r, r0, color) {
                if (end - start === 1) end -= 0.00001;
                var a0 = 2 * Math.PI * (start - 0.25);
                var a1 = 2 * Math.PI * (end - 0.25);
                var x0 = Math.cos(a0),
                    y0 = Math.sin(a0);
                var x1 = Math.cos(a1),
                    y1 = Math.sin(a1);
                var largeArc = end - start > 0.5 ? 1 : 0;

                return [
                    '<path d="M',
                    r + r0 * x0,
                    r + r0 * y0,
                    'L',
                    r + r * x0,
                    r + r * y0,
                    'A',
                    r,
                    r,
                    0,
                    largeArc,
                    1,
                    r + r * x1,
                    r + r * y1,
                    'L',
                    r + r0 * x1,
                    r + r0 * y1,
                    'A',
                    r0,
                    r0,
                    0,
                    largeArc,
                    0,
                    r + r0 * x0,
                    r + r0 * y0,
                    '" fill="' + color + '" />'
                ].join(' ');
            },
            createDonutFromCache(properties) {
                if (typeof this.createDonutFromCache.cache === 'undefined') {
                    this.createDonutFromCache.cache = []
                }

                if (!this.createDonutFromCache.cache[properties.id]) {
                    const donut = this.createDonut(properties.services);
                    this.createDonutFromCache.cache[properties.id] = donut
                }
                return this.createDonutFromCache.cache[properties.id]
            },
            createDonut(services) {
                let colors = [],
                    counts = [],
                    offsets = [];
                let total = 0;

                for(let i = 0; i < services.length; i++) {
                    colors.push(services[i].color_hex);
                    counts.push(Number(100 / services.length))
                }
                for (var i = 0; i < counts.length; i++) {
                    offsets.push(total);
                    total += counts[i];
                }

                var fontSize =
                    total >= 1000 ? 22 : total >= 100 ? 20 : total >= 10 ? 18 : 16;
                var r = total >= 1000 ? 50 : total >= 100 ? 26 : total >= 10 ? 24 : 18;
                var r0 = Math.round(r * 0.6);
                var w = r * 2;

                var html =
                    '<div><div class="donut"><svg class="gym" width="' +
                    w +
                    '" height="' +
                    w +
                    '" viewbox="0 0 ' +
                    w +
                    ' ' +
                    w +
                    '" text-anchor="middle" style="font: ' +
                    fontSize +
                    'px sans-serif">';

                for (i = 0; i < counts.length; i++) {
                    html += this.donutSegment(
                        offsets[i] / total,
                        (offsets[i] + counts[i]) / total,
                        r,
                        r0,
                        colors[i]
                    );
                }
                html +=
//                   '<defs><pattern id="image" x="0%" y="0%" height="100%" width="100%"  viewBox="0 0 26 26"> <image class="img" x="0%" y="0%" width="26" height="26" xlink:href="/gym.svg" ></image>    </pattern> </defs>' +
                    '<circle fill="url(#image)" class="donut__circle" cx="' +
                    r +
                    '" cy="' +
                    r +
                    '" r="' +
                    18 +
                    '" fill="white" /></svg></div>';

                var el = document.createElement('div');
                el.innerHTML = html;
                return el.firstChild;
            }
        },
        beforeDestroy() {
            this.createDonutFromCache.cache = [];
        }
    }
</script>